import { graphql } from '@/gql/generated'

export const getRandomCoverImageProjectsDocument = graphql(`
  query GetRandomCoverImageProjects($seed: seed_float!) {
    list_projects_metadata_random(
      limit: 12
      where: { complete: { _eq: true }, vertical_name: { _eq: "curated" }, tokens: { image_id: { _is_null: false } } }
      args: { seed: $seed }
    ) {
      ...CoverImageProject
    }
  }

  fragment CoverImageProject on projects_metadata {
    name
    artist_name
    aspect_ratio
    featured_token {
      invocation
      owner_address
      media_url
    }
  }
`)

export const getTokenCountPerWalletDocument = graphql(`
  query GetTokenCountPerWallet($walletAddresses: [String!]!) {
    users(where: { public_address: { _in: $walletAddresses } }) {
      public_address
      tokens_aggregate {
        aggregate {
          count
        }
      }
    }
  }
`)
